<template>
  <v-card :loading="loading" flat>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <v-autocomplete
          v-model="search"
          :items="categories"
          clear-icon="mdi-close-circle-outline"
          clearable
          dense
          item-text="title"
          :label="$t('search')"
          outlined
          @change="getData(undefined)"
        />
      </v-col>

      <v-col cols="0" md="6" />

      <template v-if="type === 'visitCard'">
        <v-col
          v-for="({ qr, id }, i) in computePhoto"
          :key="i"
          class="mb-6 pa-2"
          cols="12"
          md="2"
        >
          <v-card :disabled="selectLoading" flat>
            <div
              :style="{
                background: `url(${qr.data.data.photo.headBackground})`,
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': ' no-repeat',
                height: '14rem',
              }"
              class="card-style p-0"
              @click="selectCard(qr.data.data, i, id, qr.data.theme)"
            >
              <div
                class="position-absolute"
                style="right: 0; top: 0; z-index: 2"
              >
                <img
                  :src="qr.data.data.photo.profile"
                  alt=""
                  class="rounded-circle border border-2 img-fluid"
                  width="50"
                />
              </div>
            </div>
            <v-card-subtitle>{{ qr.data.data.visitName }}</v-card-subtitle>
          </v-card>
        </v-col>
      </template>

      <template v-else>
        <v-col
          v-for="({ qr, id }, i) in computePhoto"
          :key="i"
          class="mb-6 pa-2"
          cols="12"
          md="2"
        >
          <template v-if="!!qr.data && !!qr.data.data">
            <div
              :style="{ background: `url(${visitImage(qr.data.data)})` }"
              class="card-style"
              @click="selectCardMenu(qr.data.data)"
            ></div>
            <v-card-subtitle>{{ qr.data.data.visitName }}</v-card-subtitle>
          </template>

          <template v-else-if="!!qr.data">
            <div
              :style="{ background: `url(${menuImage(qr.data)})` }"
              class="card-style"
              @click="selectCardMenu(qr.data)"
            ></div>
            <v-card-subtitle>{{ qr.data.visitName }}</v-card-subtitle>
          </template>
        </v-col>
      </template>
    </v-row>
    <a id="dl" ref="dl"></a>
  </v-card>
</template>

<script>
import { Bus } from "@/main";

export default {
  name: "preparedCards",

  props: {
    type: {
      type: String,
      default: "visitCard",
    },
    theme: String,
    orders: Array,
  },

  data() {
    return {
      cards: [],
      observer: null,
      next_page: null,
      loading: false,
      smartID: "",
      search: undefined,
      frames: [],
      categories: [],
      selectLoading: false,
    };
  },

  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          this.next_page !== null &&
          (this.search === undefined || this.search === null)
        ) {
          this.observer.unobserve(this.$refs.dl);
          this.getData(this.next_page);
        }
      });
    });

    this.getData();
  },

  computed: {
    computePhoto() {
      let frames = [];
      this.frames = [];

      this.cards
        .filter((item) => {
          if (!this.search) return true;

          return item.title === this.search;
        })
        .forEach((item) => frames.push(item));

      this.frames = frames;
      return frames;
    },
  },

  watch: {
    smartID: {
      handler(val) {
        Bus.$emit("updateDest", val);
      },
      deep: true,
    },
  },

  methods: {
    getData(page = undefined) {
      this.loading = true;
      this.$api
        .get(`/qr/template/list`, {
          params: {
            type: this.type,
            page: page,
            search: this.search,
          },
        })
        .then(({ data }) => {
          this.categories = data.data.categories;
          if (data.data.has_next_page) {
            this.observer.observe(this.$refs.dl);
            this.next_page = data.data.next_page;
          } else this.next_page = null;

          this.cards = [...this.cards, ...data.data.data];
        })
        .catch((reason) => {
          this.$modal.error(this.$t("error"), this.$t("data_fetch_error"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectCard(item, index, card_id, theme) {
      this.selectLoading = true;

      let value = {
        data: { ...item },
        theme: theme,
      };

      try {
        if (!!value.data?.video_single?.videos?.length) {
          let arr = value.data.video_single.videos.map((item) =>
            this.fixVideoGallery(item),
          );

          if (
            !!value.data?.video_gallery?.length &&
            !!value.data.video_gallery.filter((item) => item?.images?.length)
              .length
          ) {
            arr.forEach((item) => {
              value.data.video_gallery[0].images.push(item);
            });
          } else {
            value.data.video_gallery = [
              {
                images: arr,
                name: "",
              },
            ];
          }
          delete value.data.video_single;

          let orderIndex = value.orders?.findIndex(
            (item) => item.name === "video_single",
          );
          if (orderIndex >= 0) value.orders.splice(orderIndex, 1);
        }

        if (!value?.data?.audiosGallery)
          value = {
            ...value,
            data: {
              ...value.data,
              audiosGallery: { audios: [], audioType: "newPlayer" },
            },
          };
        if (!value?.data?.coordinates)
          value = {
            ...value,
            data: {
              ...value.data,
              coordinates: [51.672817, 32.657566],
            },
          };

        setTimeout(() => {
          let obj = new Object(value.data);
          if (this.type !== "menu")
            if (!obj?.photo?.gallery)
              obj.photo.gallery = [{ name: "", images: [] }];
          this.$emit("input", obj);
          this.$emit("update:theme", value.theme ?? "MobileViwer");
          if (!!value.orders?.length) this.$emit("update:orders", value.orders);

          this.smartID = card_id;
          // this.smartID = this.cards.find((item) => item.qr.data.data === value)?.id
          this.$emit("closeModel");
          this.selectLoading = false;
        }, 1500);
      } catch (e) {
        this.selectLoading = false;
      }
    },
    selectCardMenu(value, card_id) {
      let obj = new Object(value?.hasOwnProperty("data") ? value.data : value);
      this.$emit("input", obj);
      this.smartID = card_id;
      // this.smartID = this.cards.find((item) => item.qr.data === value).id
      this.$emit("closeModel");
    },
    fixVideoGallery(data) {
      return {
        description: data.description ?? "",
        file_link: data.url ?? "",
        link: data.link ?? "",
        title: data.title ?? "",
        name: "",
        id: 11,
      };
    },
    visitImage(data) {
      return data?.gallery?.[0]?.images?.[0]?.url
        ? data.gallery[0].images[0].url
        : "/media/defaults/default_image.png";
    },
    menuImage(data) {
      return data?.banner?.gallery?.[0]?.images?.[0]?.url
        ? data.banner?.gallery[0].images[0].url
        : "/media/defaults/default_image.png";
    },
  },
};
</script>

<style scoped>
.card-style {
  cursor: pointer;
  border-radius: 15px;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  height: 14rem;
}
</style>
